import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/mine/null.png'


const _withScopeId = n => (_pushScopeId("data-v-0ac78092"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message bx" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "全部消息", -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "right" }
const _hoisted_7 = { class: "top-title" }
const _hoisted_8 = { class: "item-content" }
const _hoisted_9 = {
  key: 1,
  class: "null"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "null-img"
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "暂无数据～", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

import { MessageFetch } from '@/api/request';
import { ISjqnwArticleProps, PaginationProps } from '@/api/type';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import config from '../_config';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();

const loading = ref<boolean>(false);
const finished = ref<boolean>(false);
const pagination = ref<PaginationProps>({
  pageNum: 0,
  pageSize: 5
});
const list = ref<ISjqnwArticleProps[]>([]);

const onLoad = async() => {
  // 异步更新数据
  loading.value = true;

  pagination.value.pageNum += 1;
  const params = {
    pageNum: pagination.value.pageNum,
    pageSize: pagination.value.pageSize,
    sjqnwArticleType: '1'
  };

  const res = await MessageFetch.getArticleList(params);
  const body = res.body.data;
  if (Array.isArray(body)) {
    list.value = list.value.concat(body);
    // 加载状态结束
    loading.value = false;

    // 到底了
    if (body.length === 0 || body.length < pagination.value.pageSize) {
      finished.value = true;
    }
  }
  if (!body) {
    finished.value = true;
  }
};
const toArticle = (item: ISjqnwArticleProps) => {
  router.push({
    name: 'article',
    query: {
      articleId: item.id
    }
  });
};
const toTop = () => {
  let top = document.documentElement.scrollTop || document.body.scrollTop;
  // 实现滚动效果
  const timeTop = setInterval(() => {
    document.body.scrollTop = document.documentElement.scrollTop = top -= 100;
    if (top <= 0) {
      clearInterval(timeTop);
    }
  }, 10);
};
onMounted(() => {
  onLoad();
  toTop();
});

return (_ctx: any,_cache: any) => {
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (list.value.length > 0)
        ? (_openBlock(), _createBlock(_component_van_list, {
            key: 0,
            loading: loading.value,
            "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
            finished: finished.value,
            "finished-text": "没有更多了",
            onLoad: onLoad,
            class: "active-list"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item",
                  onClick: ($event: any) => (toArticle(item)),
                  key: item.id
                }, [
                  _createElementVNode("img", {
                    src: _unref(config).articleUrl + item?.coverUrl,
                    class: "left"
                  }, null, 8, _hoisted_5),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.articleTitle), 1),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(item.intro), 1)
                  ])
                ], 8, _hoisted_4))
              }), 128))
            ]),
            _: 1
          }, 8, ["loading", "finished"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
    ])
  ]))
}
}

})